import navigation from'../../../pip/library/pi-navigation/pi-navigation.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

import { AdapterIO, IAdapterIO, IRequestIO, IResponseIO } from '../core/adapter';
import { TOptions } from '../core/interceptor';
import { dataRead } from '../helpers/raw_data';
import { t_adapter } from '../core/io';

/**
 *
 */
export type RequestAPI = RequestInit & IRequestIO;

/**
 *
 */
export type ResponseAPI = IResponseIO & {
  metadata: Record<string, unknown>;
  response: Response;
};

export type OptionsAPI = TOptions & {
  /**
   * authorization scheme determines how to inform the API of the users identity
   */
  authorization_scheme: string;
  /**
   * fetch reads headers
   */
  headers: Record<string, string>;
};

const lens = {
  metadata: f1.lens('/metadata'),
  data: f1.lens('/data')
};

/**
 *
 */
export class APIAdapterIO
  extends AdapterIO<RequestAPI, ResponseAPI, OptionsAPI>
  implements IAdapterIO<RequestAPI, ResponseAPI, OptionsAPI> {
  type = 'api' as t_adapter;

  /**
   * Request
   * 1. path is safe (navigation.uri.write)
   *
   * Response
   * 1. response is parsed with comments
   * 2. value is lifted to { data, metadata, response }, if needed
   */
  protected async _query(path: string, request: RequestAPI): Promise<ResponseAPI> {
    const response = await fetch(navigation.uri.write(path), request);
    const blob = await response.text();
    const json = dataRead(blob || '{}');

    return {
      metadata: f1.read(lens.metadata, json, json),
      data: f1.read(lens.data, json, json),
      response
    };
  }
}
